import { getShortName } from '@/shared/lib';
import type { PersonInfoResponse, PersonRoleEnum } from '../model/api/types';

/**
 * Имена всех участников роли — в порядке, в котором они пришли; участник без имени пропускается.
 * Участников одной роли у диалога бывает несколько (в текстовой коммуникации — несколько консультантов):
 * показ одного первого прятал бы остальных.
 */
export const getPersonNamesByRole = (persons: PersonInfoResponse[] | undefined, role: PersonRoleEnum): string[] =>
  (persons ?? [])
    .filter((person) => person.role === role)
    .map((person) => person.fio || getShortName(person.firstName, person.lastName, person.middleName))
    .filter(Boolean);

/**
 * Имена всех участников роли через запятую ({@link getPersonNamesByRole}) — одной строкой для ячейки списка;
 * скачанный список перечисляет их так же.
 */
export const formatPersonsByRole = (persons: PersonInfoResponse[] | undefined, role: PersonRoleEnum): string =>
  getPersonNamesByRole(persons, role).join(', ');
